<template>
  <v-row>
    <v-col cols="12">
      <v-card :loading="loading">
        <v-card-text>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Busca"
            hide-details
            clearable
          ></v-text-field>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col>
      <v-card>
        <v-card-text>
          <v-data-table
            :headers="tableHeaders"
            :items="dadosRelatorio"
            :loading="loading"
            :search="search"
            :options="{
              itemsPerPage: 15
            }"
            :footer-props="tableFooterProps"
            no-data-text="Nenhum resultado encontrado"
          ></v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "consulta-vaga",
  data: () => ({
    loading: false,
    search: "",
    dadosRelatorio: [],
    tableHeaders: [
      {
        text: "Unidade de Ensino",
        align: "start",
        sortable: true,
        value: "unidade"
      },
      {
        text: "Turma",
        align: "center",
        sortable: true,
        value: "turma"
      },
      {
        text: "Etapa",
        align: "center",
        sortable: true,
        value: "etapa"
      },
      {
        text: "Quantidade de Vagas Disponiveis",
        align: "center",
        sortable: true,
        value: "vagas"
      }
    ],
    tableFooterProps: {
      "items-per-page-options": [15, 25, 50, 100, -1],
      "items-per-page-text": "Vagas por página",
      "page-text": "{0}-{1} de {2}"
    }
  }),
  mounted() {
    this.getRelatorioConsultaVaga();
  },
  methods: {
    async getRelatorioConsultaVaga() {
      this.loading = true;
      await this.$http
        .get("relatorio-consulta-vaga")
        .then(response => {
          this.dadosRelatorio = response;
          this.loading = false;
        })
        .catch(error => {
          this.showMessage(error, "error");
          this.loading = false;
        });
    }
  }
};
</script>

<style></style>
